"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:7.2.0'] && _();
}
catch (e) { }
